import { connect } from "react-redux";
import LocationType from "./../LocationType";
import _ from "lodash";
import DisplaySwitch from "./DisplaySwitch";
import { updateDisplayType } from "./../../../../../redux/actions/surveyActions";

const mapStateToProps = (state, ownProps) => {
	//TODO selectors/reducers
	const surveyProgress = state.survey.surveyManager.surveyProgress;
	const locationTypes = surveyProgress.locationTypes || [];
	const locationTypeDataIndex = _.findIndex(locationTypes, {
		locationTypeId: ownProps.locationType.locationTypeId,
	});
	const locationTypeData =
		locationTypeDataIndex !== -1 ? locationTypes[locationTypeDataIndex] : {};
	const locationType = new LocationType(locationTypeData);
	const locationStatement = locationType.getStatement(
		ownProps.statement.statementId
	);

	const statement = locationStatement ? locationStatement : ownProps.statement;
	const isChecked = statement && statement.displayType === "matrix";

	return {
		checked: isChecked,
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		updateDisplayType: value => {
			dispatch(
				updateDisplayType(ownProps.locationType, ownProps.statement, value)
			);
		},
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(DisplaySwitch);



// WEBPACK FOOTER //
// src/components/survey/create/SurveyStepActionsKpi/SurveyStepActionsKpiTabElements/DisplaySwitchContainer.js